export const productCategory = {
  notFound: {
    title: 'Category Not Found',
    returnToProducts: 'Return to Products',
  },
  breadcrumb: {
    products: 'Products',
  },
  backButton: 'Back to Products',
  productsCount: {
    singular: 'Product',
    plural: 'Products',
  },
  productCard: {
    viewDetails: 'View Details',
  },
  cta: {
    title: 'Need Help Selecting the Right Product?',
    subtitle: 'Our technical experts are ready to assist you in finding the perfect filtration solution for your specific industrial requirements.',
    requestStudy: 'Request Technical Study',
    contactTeam: 'Contact Our Team',
  },
};